import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";

import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { WetstockRoutingModule } from "./wetstock-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { SearchFilterModule } from "src/app/shared/modules/search-filter/search-filter.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";

import { WetstockListComponent } from "./wetstock-list/wetstock-list.component";
import { WetstockRowDetailComponent } from "./wetstock-row-detail/wetstock-row-detail.component";
import { WetstockCardComponent } from "./wetstock-card/wetstock-card.component";
import { TankGraphComponent } from "../sites-Management/warehouses/tank-graph/tank-graph.component";
import { TabDatepickerModule } from "src/app/shared/modules/tab-datepicker/tab-datepicker.module";
import { NgxEchartsModule } from "ngx-echarts";

@NgModule({
  imports: [
    CommonModule,
    WetstockRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatListModule,
    MatChipsModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    SearchFilterModule,
    TabDatepickerModule,
    NgxEchartsModule
  ],
  declarations: [WetstockListComponent, WetstockRowDetailComponent, WetstockCardComponent, TankGraphComponent],
  exports: [WetstockCardComponent, TankGraphComponent],
})
export class WetstockModule {}
